export enum QUERY_KEYS {
  LOCATIONS = "locations",
  SEARCH_LOCATIONS = "searchLocations",
  INQUIRY_LOCATIONS = "inquiryLocations",
  CLUSTERS = "clusters",
  EVENT_TYPES = "eventTypes",
  LOCATION_TYPES = "locationTypes",
  INFRA_TYPES = "infraTypes",
  NUMBER_OF_MATCHING_LOCATIONS = "numberOfMatchingLocations",
  TOTAL_NUMBER_OF_LOCATIONS = "totalNumberOfLocations",
  GEOCODED_ADDRESS = "geocodedAddress",
  PLACES_AUTOCOMPLETE = "placesAutocomplete",
  PLACE_DETAILS = "placeDetails",
  WATCH_LIST = "watchList",
  HOTEL_TYPES = "hotelTypes",
  ROOM_SHAPES = "roomShapes",
  USER_INQUIRIES = "userInquiries",
  ALL_MATCHING_MARKERS = "allMatchingMarkers",
  ADS = "ads",
  TRANSLATION = "translation",
}
